@if (error$ | async; as errorMessage) {
<div class="error-message">
  {{ errorMessage || 'No error message available' }}
</div>
} @if (service$ | async; as service) {
<div class="container">
  <app-title-header></app-title-header>
  <section id="host-header" class="card">
    <ng-container>
      <div class="inline-content">
        <span data-testid="host-display-name">{{ service.name }}</span>
        <span class="title" i18n="@@SERVICE_SELECTION.TITLE">
          Select group and event types from the options below
        </span>
      </div>
    </ng-container>
  </section>
  <div id="meeting-type-container" class="row row-gutters">
    @for (meetingType of service.associations; track meetingType) {
    <div class="col col-xs-12 col-sm-6">
      <mat-card
        class="meeting-type-card"
        [routerLink]="meetingType.bookingUrl | bookingUrlPipe"
        [queryParamsHandling]="'preserve'"
      >
        <mat-card-header>
          <mat-icon
            mat-card-avatar
            class="meeting-type-icon mat-elevation-z2"
            [style.background-color]="meetingType.hexColor"
          >
            access_time
          </mat-icon>
          <mat-card-title>{{ meetingType.name }}</mat-card-title>
          <mat-card-subtitle
            >{{ durationMinutes(meetingType.duration) }}
          </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <div
            class="meeting-type-description"
            matTooltip="{{ meetingType.description }}"
            matTooltipPosition="below"
          >
            <span>{{ meetingType.description }}</span>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    }
  </div>
</div>
} @else { @if (loadingForEnoughTime$ | async) {
<div class="row row-gutters">
  @for (i of [].constructor(6); track i) {
  <div class="col col-xs-12 col-sm-6">
    <div class="stencil-shimmer meeting-type-card">
      <div
        class="meeting-type-icon mat-elevation-z2 stencil-shimmer disappear-on-mobile"
      ></div>
    </div>
  </div>
  }
</div>
} }
